'use strict';

import {staticUrl} from 'utils/django';


export default function() {
	return staticUrl;
}
